import { ConcreteException } from '../base.js';
export class GeneralException extends ConcreteException {
    static errorClass = 'GeneralException';
    parse() {
        this.setName(GeneralException.errorClass);
    }
}
//# sourceMappingURL=GeneralException.js.map